// extracted by mini-css-extract-plugin
export default {"taxonomyField":"TaxonomyField_taxonomyField__276zi"};